import { map, has, omitBy, isEmpty, isNil, isUndefined } from "lodash";
import moment from "moment";
import { OrgType } from "../../../types/customer-form.types";
import { Day } from "../../../types/common.types";

const response = (data: any) => {
  return omitBy(
    {
      _id: data._id,
      customerID: !isNil(data.orgID) ? data.orgID : undefined,
      customerName: !isNil(data.orgName) ? data.orgName : undefined,
      orgType: data.orgType,
      emailAddress: !isNil(data.contactEmail) ? data.contactEmail : undefined,
      street1: data.address.street1 || null,
      street2: data.address.street2 || null,
      city: data.address.city || null,
      cityCode: data.address.cityCode || null,
      state: data.address.state || null,
      stateCode: data.address.stateCode || null,
      postcode: data.address.postcode || null,
      country: data.address.country || null,
      primary: data.primary,
      customerLocationName: data.locationName ? data.locationName : undefined,
      handlingInstructions: data.handlingInstructions || null,
      workingHours: data.workingHours || null,
      contactPerson: data.contactPerson ? data.contactPerson : undefined,
      contactNo: {
        dialCode: data.contactNumber.countryCode,
        number: data.contactNumber.number,
      },
      locationCode: data.locationCode || undefined,
      tempDeleteInfo: !isEmpty(data.tempDeleteInfo) ? data.tempDeleteInfo : undefined,
    },
    isNil
  );
};

export default response;
